import daysBetween from "./daysBetween";

export default function getDays(seasonEnd) {
  //const current = new Date();
  //create season end date object
  //const seasonEnd = new Date('April 3, 2023 00:00:00 GMT-7:00');
  const skyDate = new Date(new Date().toLocaleDateString('en-US', { timeZone: 'US/Pacific', timeZoneName: 'short' } ))

  return (daysBetween(skyDate, seasonEnd));
}
